















































































































































import { Component, Prop, Vue, Provide, Watch } from "vue-property-decorator";
import { ReportResult } from "@/app-data/report/entities/reportEntity";
import Ipc from "@/views/base/Ipc.vue";
import { API_BIS_CATEGORY_TREE, API_BIS_REPORT_STAT } from "@/configs/Apis";
import { MONITOR_PROJECT_ID } from "@/app-data/monitor/monitor";
import { isEmptyOrWhiteSpace } from "@/utils/Common";

@Component({ components: { Ipc } })
export default class ReportFilter extends Vue {
  @Prop({ type: Object, required: true })
  reportDefine!: any;

  @Prop({ type: Object, required: true })
  reportData!: ReportResult;

  @Prop({ type: Boolean, required: true })
  dataByFilter = false;

  reportFilters: Array<any> = [];

  IGNORE_MAX_LIMIT: Array<string> = ["applicantProvince"];
  MAX_LIMIT = 20;

  years: Array<string> = [];
  months: Array<string> = [];

  activeFilters: Array<string> = [];

  defaultStartYear = 1980;
  defaultEndYear: number = new Date().getFullYear();
  defaultStartMonth = 1;
  defaultEndMonth: number = new Date().getMonth() + 1;

  categoryTreeData: Array<any> = [];
  categoryTreeDataLoaded = false;

  mounted() {
    const cyear = new Date().getFullYear();
    for (let y = 1980; y <= cyear; y++) {
      this.years.push(y + "");
    }

    for (let m = 1; m <= 12; m++) {
      if (m < 10) {
        this.months.push("0" + m);
      } else {
        this.months.push(m + "");
      }
    }
  }

  @Watch("reportData")
  onDataChange() {
    if (this.dataByFilter) {
      return;
    }

    this.reportFilters = [];
    this.activeFilters = [];
    this.categoryTreeData = [];
    this.categoryTreeDataLoaded = false;

    if (!this.reportData.dataValues ||
      this.reportData.dataValues.length === 0 ||
      this.reportData.rowCount === 0) {
      return;
    }

    const rowDimValues: Array<Array<any>> = [];
    for (let k = 0; k < this.reportData.rowCount; k++) {
      for (let i = 0; i < this.reportData.rowDimNodes[k].length; i++) {
        if (!this.reportData.rowDimNodes[k][i]) {
          continue;
        }
        if (!this.reportData.rowDimNodes[k][i].total) {
          if (!rowDimValues[i]) {
            rowDimValues[i] = [];
          }
          if (rowDimValues[i].indexOf(this.reportData.rowDimNodes[k][i].value) < 0) {
            rowDimValues[i].push(this.reportData.rowDimNodes[k][i].value);
          }
        }
      }
    }

    for (let i = 0; i < this.reportDefine.rowDims.length; i++) {
      const dim = this.reportDefine.rowDims[i];
      this.initFilterByDim(dim, rowDimValues[i] || [], "row");
    }

    if (this.reportDefine.colDims) {
      const colDimValues: Array<Array<any>> = [];
      if (this.reportDefine.colDims) {
        for (let k = 0; k < this.reportDefine.colDims.length; k++) {
          colDimValues[k] = [];
          for (let i = 0; i < this.reportData.colDimNodes.length; i++) {
            if (!this.reportData.colDimNodes[i][k]) {
              continue;
            }
            if (!this.reportData.colDimNodes[i][k].total) {
              if (colDimValues[k].indexOf(this.reportData.colDimNodes[i][k].value) < 0) {
                colDimValues[k].push(this.reportData.colDimNodes[i][k].value);
              }
            }
          }
        }
      }
      for (let i = 0; i < this.reportDefine.colDims.length; i++) {
        const dim = this.reportDefine.colDims[i];
        this.initFilterByDim(dim, colDimValues[i] || [], "col");
      }
    }
  }

  @Provide()
  get projectId() {
    if (this.$route.name === "MonitorIndex") {
      return MONITOR_PROJECT_ID;
    }

    const pInfo: any = this.$store.state.project.info || {};
    return this.$route.query.id || pInfo.id || 0;
  }

  private initFilterByDim(dim: any, dimValues: Array<any>, dimType: string) {
    if (dim.dateUnit) {
      const filter: any = {
        dimType: dimType,
        dim: dim
      };
      if (dim.dateUnit === "YEAR") {
        filter.type = "year";
        filter.startYear = this.defaultStartYear;
        filter.endYear = this.defaultEndYear;

        if (dimValues && dimValues.length > 0) {
          filter.startYear = Math.min(...dimValues);
          filter.endYear = Math.max(...dimValues);
        }

        this.reportFilters.push(filter);
        this.activeFilters.push(filter.dim.name + "_" + filter.type);
      } else if (dim.dateUnit === "MONTH") {
        for (let i = 0; i < this.reportDefine.rowDims.length; i++) {
          if (this.reportDefine.rowDims[i].name === dim.name && this.reportDefine.rowDims[i].dateUnit && this.reportDefine.rowDims[i].dateUnit === "YEAR") {
            return;
          }
        }

        if (this.reportDefine.colDims) {
          for (let i = 0; i < this.reportDefine.colDims.length; i++) {
            if (this.reportDefine.colDims[i].name === dim.name && this.reportDefine.colDims[i].dateUnit && this.reportDefine.colDims[i].dateUnit === "YEAR") {
              return;
            }
          }
        }

        filter.type = "month";
        filter.startYear = this.defaultStartYear;
        filter.startMonth = this.defaultStartMonth;
        filter.endYear = this.defaultEndYear;
        filter.endMonth = this.defaultEndMonth;

        if (dimValues && dimValues.length > 0) {
          dimValues.sort();
          const startYM = dimValues[0].split("-");
          filter.startYear = startYM[0];
          filter.startMonth = startYM[1];

          const endYM = dimValues[dimValues.length - 1].split("-");
          filter.endYear = endYM[0];
          filter.endMonth = endYM[1];
        }

        this.reportFilters.push(filter);
        this.activeFilters.push(filter.dim.name + "_" + filter.type);
      }

      return;
    }

    if (dim.name.indexOf("category") === 0) {
      this.loadCategoryTree(dim, dimValues, dimType);
      return;
    }

    const projectId = this.projectId;
    const rdim: any = {
      name: dim.name,
      label: dim.label,
      limit: 10
    };
    if (dim.table) {
      rdim.table = dim.table;
    }
    if (dim.currentId) {
      rdim.currentId = dim.currentId;
    }
    if (dim.self) {
      rdim.self = dim.self;
    }
    const definition = {
      rowDims: [rdim],
      colDims: [],
      measures: this.reportDefine.measures,
      showNoDataDims: true,
      condition: this.reportDefine.condition
    };

    this.$http.post<ReportResult>({ url: API_BIS_REPORT_STAT, path: { projectId } }, definition).then((datas) => {
      const filter = this.initFilterByDimAndData(dim, datas, dimValues, dimType);
      this.reportFilters.push(filter);
      this.activeFilters.push(filter.dim.name + "_" + filter.type);
    });
  }

  private initFilterByDimAndData(dim: any, datas: ReportResult, dimValues: Array<any>, dimType: string) {
    const filter: any = {
      dimType: dimType,
      dim: dim
    };

    if (dim.name === "patentType") {
      filter.type = "enum";
      filter.selectedDims = [];
      filter.allDims = [];
      filter.selectedDims = dimValues || [];

      for (let j = 0; j < datas.rowCount; j++) {
        let counts = [0];
        if (datas.dataValues[datas.rowColIndexes[j][0]]) {
          counts = datas.dataValues[datas.rowColIndexes[j][0]];
        }

        filter.allDims.push({
          title: datas.rowDimNodes[j][0].label,
          value: datas.rowDimNodes[j][0].value,
          count: counts.join("),(")
        });
      }
    } else {
      filter.type = "text";
      filter.selectedDims = [];
      filter.allDims = [];
      filter.minLimit = 1;
      if (this.IGNORE_MAX_LIMIT.indexOf(dim.name) < 0) {
        // filter.maxLimit = this.MAX_LIMIT;
      } else {
        filter.maxLimit = 100;
      }
      filter.loadedAll = false;
      filter.offset = 0;
      filter.dimValues = dimValues;
      filter.selectedDims = dimValues || [];

      for (let j = 0; j < datas.rowCount; j++) {
        let counts = [0];
        if (datas.dataValues[datas.rowColIndexes[j][0]]) {
          counts = datas.dataValues[datas.rowColIndexes[j][0]];
        }

        filter.allDims.push({
          title: datas.rowDimNodes[j][0].label,
          value: datas.rowDimNodes[j][0].value,
          count: counts.join("),(")
        });
      }
    }

    if (dim.limit && filter.allDims.length < dim.limit) {
      filter.loadedAll = true;
    }

    return filter;
  }

  private loadCategoryTree(dim: any, dimValues: Array<any>, dimType: string) {
    if (this.categoryTreeDataLoaded) {
      this.initCategoryDimFilter(dim, dimValues, dimType);
      return;
    }

    const projectId = this.projectId;
    this.$http.get<Array<any>>({ url: API_BIS_CATEGORY_TREE, path: { projectId: projectId } }, {}, false).then((data) => {
      const treeData: Array<any> = [];
      const map = new Map<string, any>();
      if (data && data.length) {
        data.forEach(item => {
          if (item.treeLevel === 0) {
            return;
          }

          let treeItem;
          if (map.has(item.id)) {
            treeItem = map.get(item.id);
            if (isEmptyOrWhiteSpace(treeItem.title)) {
              Object.assign(treeItem, item);
            }
          } else {
            treeItem = { name: item.name, id: item.id, parentId: item.parentId || 0, count: item.count || 0 };
            map.set(item.id, treeItem);
          }

          if (item.treeLevel === 1) {
            treeData.push(treeItem);
          } else {
            const pId = item.parentId;
            if (map.has(pId)) {
              const pItem = map.get(pId);
              if (!Object.prototype.hasOwnProperty.call(pItem, "children")) {
                pItem.children = [];
              }
              pItem.children.push(treeItem);
            } else {
              map.set(pId, { children: [treeItem] });
            }
          }
        });
      }
      this.categoryTreeData = treeData;
      this.categoryTreeDataLoaded = true;

      this.initCategoryDimFilter(dim, dimValues, dimType);
    });
  }

  private initCategoryDimFilter(dim: any, dimValues: Array<any>, dimType: string) {
    const filter: any = {
      dimType: dimType,
      dim: dim,
      type: "category",
      selectedDims: dimValues || [],
      allDims: []
    };

    for (let j = 0; j < this.categoryTreeData.length; j++) {
      if (dim.name === "category" + this.categoryTreeData[j].id) {
        filter.allDims = this.categoryTreeData[j].children;
        break;
      }
    }

    this.reportFilters.push(filter);
    this.activeFilters.push(filter.dim.name + "_" + filter.type);
  }

  loadMoreDim(filter: any) {
    if (filter.loadedAll) {
      return;
    }

    filter.offset += 10;
    const dim = filter.dim;
    const rdim: any = {
      name: dim.name,
      label: dim.label,
      limit: 10,
      offset: filter.offset
    };
    if (dim.table) {
      rdim.table = dim.table;
    }
    if (dim.currentId) {
      rdim.currentId = dim.currentId;
    }
    if (dim.self) {
      rdim.self = dim.self;
    }
    const definition = {
      rowDims: [rdim],
      colDims: [],
      measures: this.reportDefine.measures,
      showNoDataDims: true,
      condition: this.reportDefine.condition
    };

    const projectId = this.projectId;
    this.$http.post<ReportResult>({ url: API_BIS_REPORT_STAT, path: { projectId } }, definition).then((datas) => {
      if (datas.rowCount === 0) {
        filter.loadedAll = true;
        return;
      }
      for (let j = 0; j < datas.rowCount; j++) {
        let counts = [0];
        if (datas.dataValues[datas.rowColIndexes[j][0]]) {
          counts = datas.dataValues[datas.rowColIndexes[j][0]];
        }

        filter.allDims.push({
          title: datas.rowDimNodes[j][0].label,
          value: datas.rowDimNodes[j][0].value,
          count: counts.join("),(")
        });
      }

      if (datas.rowCount < 10) {
        filter.loadedAll = true;
      }
    });
  }

  reFilter() {
    const definition: any = {
      rowDims: [],
      colDims: [],
      measures: [],
      showNoDataDims: this.reportDefine.showNoDataDims
    };

    if (this.reportDefine.queryBean) {
      definition.queryBean = this.reportDefine.queryBean;
    }

    const valueRanges: any = {};
    for (let i = 0; i < this.reportFilters.length; i++) {
      const filter: any = this.reportFilters[i];
      if (filter.type === "year" && filter.startYear && filter.endYear) {
        valueRanges[filter.dimType + "_" + filter.dim.name + "__y"] = [
          filter.startYear,
          filter.endYear
        ];
      } else if (filter.type === "month" && filter.startYear && filter.endYear && filter.startMonth && filter.endMonth) {
        valueRanges[filter.dimType + "_" + filter.dim.name + "__m"] = [
          filter.startYear + "-" + filter.startMonth,
          filter.endYear + "-" + filter.endMonth
        ];
      } else if (filter.type === "enum" && filter.selectedDims && filter.selectedDims.length > 0) {
        valueRanges[filter.dimType + "_" + filter.dim.name] = [filter.selectedDims.join(",")];
      } else if (filter.type === "category") {
        const tree = this.$refs[filter.dim.name + "tree"] as any;
        const selectedIds = tree[0].getCheckedKeys();
        if (selectedIds.length === 0) {
          selectedIds.push(-1);
        }
        valueRanges[filter.dimType + "_" + filter.dim.name] = [selectedIds.join(",")];
      } else if (filter.type === "text" && filter.selectedDims && filter.selectedDims.length > 0) {
        valueRanges[filter.dimType + "_" + filter.dim.name] = [filter.selectedDims.join(",")];
      }
    }

    for (let i = 0; i < this.reportDefine.rowDims.length; i++) {
      const dim: any = JSON.parse(JSON.stringify(this.reportDefine.rowDims[i]));
      dim.limit = 0;

      let dimName = dim.name;
      if (dim.dateUnit) {
        if (dim.dateUnit === "YEAR") {
          dimName += "__y";
        } else if (dim.dateUnit === "MONTH") {
          dimName += "__m";
        }
      } else if (dim.name.indexOf("category") === 0) {
        dim.self = true;
      }
      if (valueRanges["row_" + dimName]) {
        dim.valueRange = valueRanges["row_" + dimName];
      }

      definition.rowDims.push(dim);
    }

    if (this.reportDefine.colDims) {
      for (let i = 0; i < this.reportDefine.colDims.length; i++) {
        const dim: any = JSON.parse(JSON.stringify(this.reportDefine.colDims[i]));
        dim.limit = 0;

        let dimName = dim.name;
        if (dim.dateUnit) {
          if (dim.dateUnit === "YEAR") {
            dimName += "__y";
          } else if (dim.dateUnit === "MONTH") {
            dimName += "__m";
          }
        } else if (dim.name.indexOf("category") === 0) {
          dim.self = true;
        }
        if (valueRanges["col_" + dimName]) {
          dim.valueRange = valueRanges["col_" + dimName];
        }

        definition.colDims.push(dim);
      }
    }

    for (let i = 0; i < this.reportDefine.measures.length; i++) {
      const measure: any = JSON.parse(JSON.stringify(this.reportDefine.measures[i]));
      definition.measures.push(measure);
    }

    if (!this.reportDefine.condition) {
      definition.condition = {};
    } else {
      definition.condition = JSON.parse(JSON.stringify(this.reportDefine.condition));
    }

    if (!definition.condition.items) {
      definition.condition.items = [];
    }

    const projectId = this.projectId;
    this.$http.post<ReportResult>({ url: API_BIS_REPORT_STAT, path: { projectId } }, definition).then((datas) => {
      this.$emit("reFilter", datas);
    });
  }
}
